export interface LeftJoinOperationInterface {
  tableName: string;
  alias: string;
}
